import CategoryListPage from './CategoryListPage';


export default function Dashboard(props) {
  
    return (
        <CategoryListPage />
    );
  }